module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-700italic.woff?89874573d9b2380672f3c5685263f6c4";